import { Pencil } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { CardAction } from '@/components/ui/card'

export type BriefSectionEditActionProps = {
  label: string
  onClick: () => void
}

/** Persistent pencil on mobile; hover/focus reveal on desktop. */
export function BriefSectionEditAction({ label, onClick }: BriefSectionEditActionProps) {
  return (
    <CardAction className="opacity-100 transition-opacity md:opacity-0 md:group-hover/section:opacity-100 md:group-focus-within/section:opacity-100">
      <Button
        type="button"
        variant="ghostToolbar"
        size="iconSm"
        aria-label={label}
        title={label}
        onClick={onClick}
      >
        <Pencil className="h-4 w-4" />
      </Button>
    </CardAction>
  )
}
